



















































































import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {User} from '@/types';
import {Notification} from 'element-ui';
import {Button, Checkbox} from '@/components/Base';
import {Box, Modal} from '@/components/Shared';
import {Header} from '@/components/Header';
import {ProfileForm} from '@/components/ProfileForm';
import {InviteUserBox} from '@/components/InviteUserBox';
import {Footer} from '@/components/Footer';
import {getKeycloak} from "@/components/auth/keycloak";

@Component({
  components: {
    Checkbox,
    Button,
    Modal,
    Box,
    Header,
    ProfileForm,
    InviteUserBox,
    Footer,
  },
})

export default class Profile extends Vue {
  @Getter public user: User;
  @Getter public subscriptions: any;
  @Getter public isDeleteConfirmationDisplayed: boolean;
  @Getter public isUserInvitationModalDisplayed: boolean;
  public keycloak = getKeycloak();

  public created() {
    this.$store.dispatch('fetchUserDetails');
    this.$store.dispatch('fetchNewsletters');
  }

  public showUserInvitationModal() {
    this.$store.commit('TOGGLE_USER_INVITATION_MODAL', true);
  }

  public saveSubscriptions() {
    this.$store.dispatch('saveSubscriptions');
  }

  public resetPassword() {
    Notification.success({
      title: 'Logging out!',
      message: 'You\'ll be logged out in a moment. Please check your inbox',
      customClass: 'app-notification',
      onClose: () => this.$store.dispatch('resetPassword'),
    });
  }

  public handleModalCloseClick() {
    this.$store.commit('TOGGLE_USER_INVITATION_MODAL', false);
  }

  public toggleDeleteConfirmation() {
    this.$store.commit('TOGGLE_DELETE_CONFIRMATION', !this.isDeleteConfirmationDisplayed);
  }

  public deleteUserAccount() {
    this.$store.dispatch('deleteUserAccount');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Profile/Profile.vue